<div *ngIf="credolabLoading" class="text-center text-muted py-4">
    <i class="fas fa-spinner fa-spin me-2"></i> Cargando configuración...
</div>

<div *ngIf="!credolabLoading && credolabNotSeeded" class="alert alert-warning">
    <strong>Credolab no está sembrado.</strong>
    Correr <code>node seed_approval_policy.js</code> en el backend para inicializar la configuración.
</div>

<div *ngIf="!credolabLoading && !credolabNotSeeded && credolabData">

    <div class="mb-3 small text-muted">
        Flags de auto-rechazo por dispositivo, red, perfil y origen de instalación.
        Un flag activado rechazará automáticamente al cliente si Credolab lo reporta con
        severidad <strong>alta</strong> o <strong>muy alta</strong>. Basta con que UNO
        de los flags activados se dispare para rechazar.
    </div>

    <div *ngFor="let category of CATEGORY_ORDER" class="mb-4">
        <h6 class="mb-2 d-flex align-items-center gap-2">
            <span>{{ getCategoryLabel(category) }}</span>
            <span class="badge bg-light text-dark border">
                {{ countEnabledFlagsByCategory(category) }} / {{ getFlagsByCategory(category).length }} activos
            </span>
        </h6>

        <div class="list-group">
            <div class="list-group-item d-flex justify-content-between align-items-center"
                 *ngFor="let flag of getFlagsByCategory(category)">
                <div class="flex-grow-1 pe-3">
                    <div class="fw-medium small">{{ flag.label }}</div>
                    <div class="small text-muted mt-1">{{ flag.description }}</div>
                    <code class="small text-muted d-block mt-1">{{ flag.code }}</code>
                </div>
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox"
                           [checked]="isFlagEnabled(flag.code)"
                           [disabled]="isFlagSaving(flag.code)"
                           (change)="toggleFlag(flag.code, isFlagEnabled(flag.code))">
                    <span *ngIf="isFlagSaving(flag.code)" class="spinner-border spinner-border-sm ms-2"></span>
                </div>
            </div>
        </div>
    </div>

    <div class="small text-muted mt-3" *ngIf="credolabData.updatedBy || credolabData.updatedAt">
        Última actualización:
        <strong *ngIf="credolabData.updatedBy">{{ credolabData.updatedBy }}</strong>
        <span *ngIf="credolabData.updatedAt">· {{ credolabData.updatedAt | date:'dd MMM yyyy, HH:mm' }}</span>
    </div>
</div>
